__turbopack_context__.v({
  "closeButton": "nlutgW_closeButton",
  "copyButton": "nlutgW_copyButton",
  "header": "nlutgW_header",
  "headerActions": "nlutgW_headerActions",
  "headerLeft": "nlutgW_headerLeft",
});
